import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Paper,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: props => theme.customShadows[props.color][props.type][props.elevation],
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  }
}))

function ColorPaper({ color = 'primary', type = 'dark', elevation = 0, children, ...inputProps }) {
  const classes = useStyles({ color, type, elevation })
  return (
    <Paper classes={{ ...classes }} elevation={elevation} {...inputProps}>
      {children}
    </Paper>
  )
}

export default ColorPaper
